import React, {
  ReactElement,
  useEffect,
  useRef,
  useState,
  Fragment, useMemo,
} from 'react';
import Tooltip from '@mui/material/Tooltip';

export const AddressCell = ({ props }: { props: any }): ReactElement => {
  const divRef = useRef(null);
  const [tooltip, setTooltip] = useState(false);

  function getDivWidth(divRef: any) {
    if (divRef && divRef.current) {
      const divElement = divRef.current;
      const parentElement = divElement.parentNode;

      const divRect = divElement.getBoundingClientRect();
      const parentRect = parentElement.getBoundingClientRect();

      return {
        element: divRect.width,
        cell: parentRect.width,
      };
    }
    return {
      element: 0,
      cell: 0,
    };
  }

  useEffect(() => {
    setTooltip(false);
    const divWidth: { element: number; cell: number } = getDivWidth(divRef);

    if (
      divWidth['element'] > divWidth['cell']
    ) {
      setTooltip(true);
    }
  });

  const value =useMemo(() =>{

    const defaultValue = props.value;

    let name  = '';
    if (defaultValue?.name){
      name = defaultValue?.name;
      if (defaultValue?.address_line1 && defaultValue?.address_line1!=defaultValue?.name){
        name  = `${name} (${defaultValue?.address_line1})`;
      }
    }else{
      name = defaultValue?.address_line1;
    }
    return name;

  },[props]);

  return (
    <span
      ref={divRef}
    >
      {tooltip ? (
        <>
          <Tooltip
            disableInteractive
            title={value}
            slotProps={{
              tooltip: {
                sx: {
                  fontSize: '13px',
                },
              },
              popper: {
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [0, -14],
                    },
                  },
                ],
              },
            }}
          >
            <>
              {value}
            </>
          </Tooltip>
        </>
      ) : (
        <>
          {value}
        </>
      )}
    </span>
  );
};
